import React, { useMemo } from "react";
import styles from "./Style.module.css";
import { removeUnderScore } from "../../../../../helper/helper";

const CustomTable = ({
  columns,
  currentYearData,
  title,
  prevYearData,
  sheetData,
  isSheet,
  isType4Value
}) => {
  const renderCell = (item, column) => {
    if (typeof column.render === "function") {
      return column.render(item);
    }
    return item[column.key];
  };

  const reducedPercentageSum = useMemo(() => {
  const source = Array.isArray(isType4Value) && isType4Value?.length > 0 
    ? isType4Value 
    : currentYearData;

  if (!Array.isArray(source)) return 0;

  return source.reduce(
    (acc, item) => acc + (item?.ratings?.percentage ?? 0),
    0
  );
}, [currentYearData, isType4Value]);

const averageCurrentYearPercentage = useMemo(() => {
  const source = Array.isArray(isType4Value) && isType4Value.length > 0 
    ? isType4Value 
    : currentYearData;

  const count = Array.isArray(source) ? source.length : 0;
  if (count === 0) return 0;

  return Number(reducedPercentageSum / count) || 0;
}, [reducedPercentageSum, currentYearData, isType4Value]);

  const reducedPrevYearPercentageSum = useMemo(
  () =>
    prevYearData?.reduce((acc, item) => {
      return acc + (item?.ratings?.percentage ?? 0);
    }, 0) ?? 0,
  [prevYearData]
);

  const averagePrevYear =
  prevYearData && prevYearData?.length > 0
    ? reducedPrevYearPercentageSum / prevYearData.length
    : 0;

// Change by
const changeBy = useMemo(() => {
  const current = Number(averageCurrentYearPercentage) || 0;
  const prev = Number(averagePrevYear) || 0;
  return current - prev;
}, [averageCurrentYearPercentage, averagePrevYear]);

// Goal Sheet-A
const changeBySheed = useMemo(() => {
  const final = sheetData?.final_rating ?? 0;
  const lastYear = sheetData?.last_year_final_rating ?? 0;
  return Number(final) - Number(lastYear);
}, [sheetData?.final_rating, sheetData?.last_year_final_rating]);

  return (
    <table className={styles.table}>
      <thead>
        {title && (
          <tr>
            <th></th>
            <th colspan="2" className={styles.theadTitle}>
              {title}
            </th>
          </tr>
        )}

        <tr>
          {columns?.map((column) =>
            column.key === "test" ? (
              <th key={column.key}>{column.title}</th>
            ) : (
              <th
                key={column.key}
                colSpan={
                  column.key === "test" ? 1 : columns?.length > 2 ? 1 : 2
                }
                className={styles.thead}
              >
                {column.title}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {currentYearData?.map((item, index) => (
          <tr
            key={index}
            className={
              item?.key === "avg" || item?.key === "count"
                ? styles.blueField
                : styles.evenRow
            }
          >
            {columns?.map((column) => (
              <>
                <td
                  key={column.key}
                  className={styles.columData}
                  colSpan={
                    column.key === "test" ? 1 : columns?.length > 2 ? 1 : 2
                  }
                >
                  {renderCell(
                    column?.dataSource ? column?.dataSource[index] : item,
                    column
                  )}
                </td>
              </>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className={styles.blueField}>
          <td className={styles.columData}>
            <div className={styles.labelhead}>Total</div>
          </td>
          {sheetData?.last_year || averagePrevYear ? (
            <td className={styles.columData}>
              <div className={styles.label}>
                {isSheet
                  ? sheetData?.last_year_final_rating
                  : averagePrevYear?.toFixed(2)}
                %
              </div>
            </td>
          ) : (
            ""
          )}
          {sheetData?.year || averageCurrentYearPercentage ? (
            <td className={styles.columData}>
              <div className={styles.label}>
                {" "}
                {isSheet
                  ? sheetData?.final_rating
                  : averageCurrentYearPercentage?.toFixed(2)}
                %
              </div>
            </td>
          ) : (
            ""
          )}
        </tr>
        <tr className={styles.blueField}>
          <td className={styles.columData}>
            <div className={styles.label}>Change By </div>
          </td>

          <td className={styles.columData} colSpan="2">
            <div className={styles.label}>
              {isSheet ? changeBySheed.toFixed(2) : changeBy?.toFixed(2)}%
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

function AwardTable({
  currentYearData=[],
  title,
  prevYearData=[],
  sheetData,
  isSheet,
  isType4Value
}) {
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  const columns = useMemo(
    () => [
      {
        key: "test",
        title: "",
        render: (all) => (
          <div className={styles.labelhead}>{removeUnderScore(all?.title)}</div>
        ),
      },
      ...(sheetData?.last_year
        ? [
            {
              key: String(previousYear),
              title: String(previousYear),
              dataSource: prevYearData,
              render: (all) => (
                <div className={styles.label}>{all?.ratings?.percentage}%</div>
              ),
            },
          ]
        : []),
      ...(sheetData?.year
        ? [
            {
              key: String(currentYear),
              title: String(currentYear),
              dataSource: currentYearData,
              render: (all) => (
                <div className={styles.label}>{all?.ratings?.percentage}%</div>
              ),
            },
          ]
        : []),
    ],
    [sheetData?.last_year, sheetData?.year, prevYearData, currentYearData, currentYear, previousYear]
  );
  return (
    <div>
      {
        <CustomTable
          title={title}
          columns={columns}
          currentYearData={currentYearData}
          prevYearData={prevYearData}
          sheetData={sheetData}
          isSheet={isSheet}
          isType4Value={isType4Value}
        />
      }
    </div>
  );
}

export default AwardTable;
